import { CloudinaryImage_File } from 't2-graphql-types';

const isCloudinaryImageFile = (data: any): data is CloudinaryImage_File => typeof data === 'object' && data?.publicUrl;

export default isCloudinaryImageFile;
